import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import * as CertificationWatermark from '@tableau/certification-watermark';
import * as React from 'react';

export function CertificationMarkTooltipCell(
    isCertified: (row: DataGrid.Row) => boolean,
    getTooltipProps: (row: DataGrid.Row) => CertificationWatermark.CertificationTooltipProps
): React.Factory<BodyCell.Props> {
  return React.createFactory(class extends React.Component<BodyCell.Props, any> {
    displayName: 'CertificationMarkTooltipCell';

    render() {
      if (isCertified(this.props.row)) {
        const tooltipProps = getTooltipProps(this.props.row);
        return <CertificationWatermark.CertificationTooltipComponent {...tooltipProps} />;
      } else {
        return <span></span>;
      }
    }
  });
}
